module.exports = __webpack_public_path__ + "img/健康饮食预告.71db29aa.jpg";